import * as React from 'react';

const SvgCalendar = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    stroke="#56565b"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="calendar_svg__feather calendar_svg__feather-calendar"
    {...props}
  >
    <rect x={3} y={4} width={18} height={18} rx={2} ry={2} />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);

export default SvgCalendar;
